import { MutableRefObject, useContext, useEffect, useRef } from 'react'
import { RoomContext, RoomContextState, RoomContextType } from '../RoomContext'

export default function useRoomContextRef() {
    const { state: roomState } = useContext(RoomContext) as RoomContextType

    const roomStateRef = useRef<RoomContextState>(roomState)

    useEffect(() => {
        roomStateRef.current = roomState
    }, [roomState])

    return {
        roomStateRef: roomStateRef as MutableRefObject<RoomContextState>,
    }
}
